<template>
  <div class="row items-center q-pb-md q-pt-md">
    <p :class="[color, 'text-h6 q-pr-md']">{{category.name}}</p>
    <div class="gradient q-ml-md"></div>
  </div>
</template>
<script>
export default {
  name: 'CategoryMobile',
  props: {
    category: Object,
    color: String
  }
}
</script>
<style lang="scss" scoped>
p {
  font-weight: 800;
  font-family: sans-serif;
  margin: 0;
}
</style>